
<div class="container">
  <div class="row">
    <div class="col-12">
      <slideshow
      *ngIf="images && images.length > 0"
      [minHeight]="'400px'"
      [autoPlay]="images.length > 1"
      [showArrows]="false"
      [showCaptions]="true"
      [showDots]="true"
      [hideOnNoSlides]="true"
      [lazyLoad]="true"
      [autoPlayWaitForLazyLoad]="true"
      [imageUrls]="images">
    </slideshow>
    </div>
  </div>
  <div class="row d-md-none mt-5">
    <div class="col-12">
      <h2 class="text-stem text-center" style="font-size:1.3rem">{{'CONFIGURATORE' | translate | htmlToText}}</h2>
    </div>
    <div class="col-12">
      <!-- //MODULO BANNER -->
      <div class="container-fluid no-print mt-3" *ngIf="isMobile">
        <app-configuratore *ngIf="strutturaGradinatore" [struttura]="strutturaGradinatore" (queryParamsChange)="queryParamsChange($event)" (risultatiStaffeChange)="risultatiStaffeChange()"></app-configuratore>
      </div>
    </div>
  </div>
</div>


<div class="mt-5">
  <app-blocco *ngFor="let blocco of blocchi" [data]="blocco"></app-blocco>
</div>
